"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transform = void 0;
const sync_1 = require("csv-parse/sync");
const core = __importStar(require("@actions/core"));
function Transform(inputs) {
    let images = [];
    // backward compatibility with old format
    if (inputs.length == 1) {
        let newformat = false;
        const fields = (0, sync_1.parse)(inputs[0], {
            relaxColumnCount: true,
            skipEmptyLines: true
        })[0];
        for (const field of fields) {
            const parts = field
                .toString()
                .split('=')
                .map(item => item.trim());
            if (parts.length == 1) {
                images.push({ name: parts[0], enable: true });
            }
            else {
                newformat = true;
                break;
            }
        }
        if (!newformat) {
            return output(images);
        }
    }
    images = [];
    for (const input of inputs) {
        const image = { name: '', enable: true };
        const fields = (0, sync_1.parse)(input, {
            relaxColumnCount: true,
            skipEmptyLines: true
        })[0];
        for (const field of fields) {
            const parts = field
                .toString()
                .split('=')
                .map(item => item.trim());
            if (parts.length == 1) {
                image.name = parts[0];
            }
            else {
                const key = parts[0].toLowerCase();
                const value = parts[1];
                switch (key) {
                    case 'name': {
                        image.name = value;
                        break;
                    }
                    case 'enable': {
                        if (!['true', 'false'].includes(value)) {
                            throw new Error(`Invalid enable attribute value: ${input}`);
                        }
                        image.enable = /true/i.test(value);
                        break;
                    }
                    default: {
                        throw new Error(`Unknown image attribute: ${input}`);
                    }
                }
            }
        }
        if (image.name.length == 0) {
            throw new Error(`Image name attribute empty: ${input}`);
        }
        images.push(image);
    }
    return output(images);
}
exports.Transform = Transform;
function output(images) {
    core.startGroup(`Processing images input`);
    for (const image of images) {
        core.info(`name=${image.name},enable=${image.enable}`);
    }
    core.endGroup();
    return images;
}
